import logo from './abRiskManagement.png';

export const AlanBoswellLogo = () => {
  return (
    <img src={logo} className="h-12"/>
  );
};
